// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","209":"component---src-pages-contact-js","293":"component---src-pages-index-js","316":"component---src-pages-menu-js"}[chunkId] + "-" + {"125":"eacf495c60d1a0c038e7","209":"0a9dc9f33c2536541928","293":"0c7a2f155ee87e291113","316":"b94e0a794582a52fa6b4"}[chunkId] + ".js";
};